<ion-card class="card-container">
  <ion-card-content data-cy="clear-data-title-text">
    <div class="header-info">
      <h2>{{ 'i18n.profilePage.clearData.title' | translate }}</h2>
      <h3 [innerHTML]="text"></h3>
    </div>
    <div class="footer-buttons">
      <ion-button
        data-cy="clear-data-button"
        [ngClass]="'usf-outline-green-button'"
        expand="block"
        (click)="confirmClearAppData()"
        >{{ 'i18n.profilePage.clearData.title' | translate }}</ion-button
      >
    </div>
  </ion-card-content>
</ion-card>
